import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { allPass, always, ifElse, prop, complement, path, isNil, both, identity } from 'ramda';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import { Container, DiscountInfo } from './experienceSummary.styles';
import { SUMMARY_PRIMARY_TYPE, SUMMARY_TYPES } from './experienceSummary.constants';
import {
  getPeopleMessageProps,
  getPrice,
  getGroupSizeMessageProps,
} from '../../../shared/utils/experienceSummary/experienceSummary';
import messages from './experienceSummary.messages';
import { PriceDisplay } from '../../../shared/components/priceDisplay';

export class ExperienceSummaryBase extends PureComponent {
  static propTypes = {
    experience: PropTypes.object.isRequired,
    className: PropTypes.any,
    showGroupSize: PropTypes.bool,
    hideDiscountBorder: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    type: PropTypes.oneOf(SUMMARY_TYPES),
    onDiscountInfoClick: PropTypes.func,
  };

  static defaultProps = {
    type: SUMMARY_PRIMARY_TYPE,
    onDiscountInfoClick: identity,
  };

  get groupSize() {
    const groupSize = getGroupSizeMessageProps(this.props.experience);
    const { formatMessage } = this.props.intl;

    return ifElse(
      both(complement(isNil), () => this.props.showGroupSize),
      ({ values, ...message }) => formatMessage(messages.groupSizeInfo, { size: formatMessage(message, values) }),
      always('')
    )(groupSize);
  }

  get extraText() {
    return ifElse(
      allPass([prop('discountPercent'), prop('discountThreshold'), complement(path(['tickets', 'isGroup']))]),
      () => (
        <Fragment>
          {' • '}
          <DiscountInfo onClick={this.handleDiscountInfoClick}>
            {this.props.intl.formatMessage(messages.groupInfo)}
          </DiscountInfo>
        </Fragment>
      ),
      always('')
    )(this.props.experience);
  }

  get guests() {
    const { minGroupSize, maxGroupSize, tickets } = this.props.experience;
    const { values, ...message } = getPeopleMessageProps({ minGroupSize, maxGroupSize, tickets });

    return this.props.intl.formatMessage(message, values);
  }

  get price() {
    return <PriceDisplay value={getPrice(this.props.experience.tickets)} />;
  }

  handleDiscountInfoClick = () => this.props.onDiscountInfoClick();

  render() {
    const { duration } = this.props.experience;

    return (
      <ThemeProvider theme={{ type: this.props.type, hideDiscountBorder: this.props.hideDiscountBorder }}>
        <Container className={this.props.className}>
          <FormattedMessage
            {...messages.info}
            values={{
              duration,
              guests: this.guests,
              price: this.price,
              groupSize: this.groupSize,
              extraText: this.extraText,
            }}
          />
        </Container>
      </ThemeProvider>
    );
  }
}

export const ExperienceSummary = injectIntl(ExperienceSummaryBase);
